import { toast } from 'react-toastify'

import { handleErrorMsg } from 'utils'

export const requestError = message => toast.error( typeof message === 'object' ? handleErrorMsg( message ) : message )

export const requestSuccess = message => toast.success( message )